export const isNotNullOrUndefined = (value) => {
    return value != null;
};
export const isNullOrUndefined = (value) => {
    return value == null;
};
export const isFalsy = (value) => {
    if (typeof value === 'string') {
        return value === '' || isNullOrUndefined(value);
    }
    if (typeof value === 'number') {
        return value === 0 || isNullOrUndefined(value);
    }
    if (typeof value === 'boolean') {
        return value === false || isNullOrUndefined(value);
    }
    return isNullOrUndefined(value);
};
export function isObject(value) {
    if (value === null) {
        return false;
    }
    if (typeof value !== 'object') {
        return false;
    }
    return true;
}
//# sourceMappingURL=index.js.map